package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar


data class MonthModel(
    val dayNumber:Int=0,
    val monthName:String="",
    val yearNumber:Int=0,
    val monthNumber:Int=0,
    val days:List<DayModel> = listOf()
)